import type { WhatsNewBody } from '../types';

export default {
  title: 'Accruals in the month-end Excel export',
  summary:
    'The Excel export of a past month in Reports > Work-in-Progress has a new Accruals sheet: every job’s saved month-end accruals on one list, so the month’s journal can be booked from one file.',
  details: [
    'One line per accrual. Job, vendor, description, cost code, kind and amount come first, and the line’s own figures sit beside them.',
    'The lines are as the project managers have them saved when the file is made. Closing the month does not freeze accruals, so one can still be changed afterward.',
    'The amounts are not in Cost to date or any other figure in the file. Accruals stay a schedule.',
    'A job that has since been deleted is listed apart at the bottom, with its own total, and is not in the Total above it.',
  ],
  audience: { label: 'accounting and everyone who uses the Work-in-Progress report', test: (a) => a.viewsFinancials },
  tryIt: { to: '/reports', label: 'Open Reports' },
  guide: { topic: 'mod-commitments-accruals' },
} satisfies WhatsNewBody;
